import {axiosJWTInstance} from "./axiosJWTInstance";

export interface FeaturesAllowedDto {
    feature: string;
    isAllowed: boolean;
}

export enum FeaturesAllowedName {
  BUDGETS = "budgets",
  REJECTED_ORDER = "rejected_orders"  
}

export const getFeaturesAllowed = (): Promise<FeaturesAllowedDto[]> => {
  const defaultVal: FeaturesAllowedDto = {
      feature: "orders",
      isAllowed: true
  };
  return axiosJWTInstance.get(`/Settings/Features`)
      .then(res => [defaultVal, ...res.data])
      .catch(err => {
        console.log("Error fetcheando permisos");
        console.log(err);
        return [defaultVal];
      });
};

export interface IndicatorsDto {
    reintentosQuantity: number;
    pendienteDescargaQuantity: number;
}

export const getIndicators = (): Promise<IndicatorsDto> => {
    const url = `/Orders/GetIndicators`;

    return axiosJWTInstance
      .post(url, {
          headers: {
              "Access-Control-Allow-Origin": "*",
              "content-type": "application/json",
          }
      })
      .then(res => res.data)
      .catch(err => {
        console.log("Error fetcheando indicadores");
        console.log(err);
      });
};